module.exports = __webpack_public_path__ + "images/p2p.e2c8e8f4b40f5ba87483b970b02580c9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/header/imgs/p2p.jpg
// module id = ./src/header/imgs/p2p.jpg
// module chunks = 1